import PersonIcon from "@mui/icons-material/Person";
import ChatComponent from "../ChatComponent";
import { AppBar, Box, Toolbar } from "@mui/material";
import * as React from "react";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { selectUser } from "../../store/slice/user";
import { IMAGES } from "../../theme";
import CustomButton from "../CustomButton";
import MainMenu from "../DropDowns/MainMenu";
import MobileNumberModal from "../Modals/MobileNumber";
import Profile from "../Modals/Profile";
import { Style } from "./style";
import { useTranslation } from "react-i18next";

// Matches new-design/o7events-frontend's <nav> exactly: fixed, blurred,
// logo on one side, exactly two pill buttons (Create An Event / Login) on
// the other — no hamburger/side-drawer, new-design's homepage nav doesn't
// have one. Logged-in account actions (profile/tickets/favorites/logout,
// previously reachable via the drawer) are already fully covered by the
// avatar's MainMenu dropdown, so nothing is lost by dropping the drawer.
// Search moved to the Home hero (SearchBar component) — new-design's own
// `.search-bar` CSS class is never placed in its markup, so there's no
// "correct" nav position for it to preserve.
const Navbar = () => {
  const navigate = useNavigate();
  const user = useSelector(selectUser);
  const [open, setOpen] = useState(false);
  const [openProfile, setOpenProfile] = useState(false);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = useState(null);
  const isHome = useLocation()?.pathname == "/";
  const { t } = useTranslation();

  let { language } = user;
  const isEmployee = localStorage.getItem("isEmployee");

  const openLink = () => {
    let url = "https://admin.o7events.com/vendor";
    window.open(url, '_blank', 'noopener,noreferrer')
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };
  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };
  const mobileMenuId = "primary-search-account-menu-mobile";
  const isArabic = language === "ar";

  return (
    <Box sx={Style.main(isHome, isEmployee)}>
      <ChatComponent />

      <AppBar position="fixed" sx={Style.appBar}>
        <Toolbar
          sx={{
            ...Style.toolbar,
            flexDirection: isArabic ? "row-reverse" : "row",
          }}
        >
          <Box display="flex" alignItems="center" flexDirection={isArabic ? "row-reverse" : "row"}>
            <Box
              component={"div"}
              onClick={() => navigate("/")}
              sx={Style.logoContainer(isArabic)}
            >
              <Box component={"img"} src={IMAGES.LogoIcon} sx={Style.logoImg} />
            </Box>
          </Box>
          <Box sx={Style.optionsContainer(isArabic)}>
            <CustomButton
              onClick={() => openLink()}
              sx={Style.loginButtonSmall(isArabic)}
              buttonText={t("navbar.createEvent")}
              color="secondary"
            />
            {!user.name ? (
              <CustomButton
                onClick={() => setOpen(true)}
                sx={Style.loginButton(isArabic)}
                buttonText={t("navbar.login")}
                color="secondary"
              />
            ) : (
              <Box sx={Style.langName(isArabic)} onClick={handleMobileMenuOpen}>
                <PersonIcon style={Style.avatar} />
              </Box>
            )}
          </Box>
        </Toolbar>
      </AppBar>
      <MainMenu
        anchorEl={mobileMoreAnchorEl}
        id={mobileMenuId}
        onClick={handleMobileMenuClose}
        onClose={handleMobileMenuClose}
        setOpenProfile={setOpenProfile}
      />
      <Profile open={openProfile} setOpen={setOpenProfile} />
      <MobileNumberModal open={open} setOpen={setOpen} />
    </Box>
  );
};

export default Navbar;
